export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=template&id=657b15d2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modal.vue?vue&type=template&id=657b15d2&
// module id = 1325
// module chunks = 0